<template>
  <!-- <a-page-header title="用户详情" sub-title="关联信息"
    @back="() => $router.go(-1)"/>
  <a-button type="danger" size="large" style="float: right; margin-top: -52px"
    @click="showDeleteConfirm" v-if="data && !data.is_superuser">
    删除
  </a-button>
  <a-row :gutter="16" style="min-height: 63px;"> -->
  <div class="block">
    <div class="delBtn" @click="showDeleteConfirm" v-if="data && !data.is_superuser">
      删除
    </div>
    <a-col :span="6">
      <a-statistic title="用户名" :value="data.username" v-if="data"> </a-statistic>
    </a-col>
    <a-col :span="8">
      <a-statistic title="邮箱" :value="data.email" v-if="data && data.email"> </a-statistic>
      <a-statistic title="邮箱" :value="i18n.t('null')" v-if="data && !data.email"> </a-statistic>
    </a-col>
    <a-col :span="4">
      <a-statistic
        title="患者数"
        :value="data.createdPatients.length"
        groupSeparator=""
        v-if="data"
      >
      </a-statistic>
    </a-col>
    <a-col :span="4">
      <a-statistic title="报告数" :value="data.createdReports.length" groupSeparator="" v-if="data">
      </a-statistic>
    </a-col>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import { Modal } from "ant-design-vue";

export default {
  setup() {
    const i18n = useI18n();
    return {
      i18n
    };
  },
  created() {
    this.fetchUserDetail();
  },
  data() {
    return {
      data: null
    };
  },
  computed: {},
  methods: {
    ...mapActions("user", ["getUserDetail", "deleteUser"]),
    async fetchUserDetail() {
      const data = await this.getUserDetail(this.$route.params.userId);

      this.data = data;
    },
    showDeleteConfirm() {
      Modal.confirm({
        title: "真的要删除吗？",
        icon: createVNode(ExclamationCircleOutlined),
        content: this.data.username,
        cancelText: "取消",
        okText: "确定",
        onOk: async () => {
          try {
            await this.deleteUser(this.data.id);

            this.$message.success("删除成功");
            this.$router.go(-1);
          } catch (error) {
            console.log(error);
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.block {
  width: 100%;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
}
.delBtn {
  position: absolute;
  right: 30px;
  top: 0;
  width: 40px;
  height: 50px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding: 9px 6px 23px 6px;
  cursor: pointer;
  background: url("../assets/delBtn.png");
  background-size: 40px 50px;
}
.ant-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .ant-statistic-title {
  color: #999;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
::v-deep .ant-statistic-content {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #171b1e;
}
</style>
